var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOndas2 = function SvgOndas2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B985C",
    fillRule: "evenodd",
    d: "M18.543.231c1.96 2.044 3.171 4.866 3.171 7.982 0 3.125-1.219 5.954-3.189 8l-.7-.725c1.793-1.86 2.902-4.433 2.902-7.275 0-2.831-1.1-5.394-2.88-7.253l.696-.729zM3.19.212l.699.725C2.096 2.797.987 5.37.987 8.213c0 2.831 1.1 5.395 2.88 7.253l-.696.728C1.21 14.15 0 11.33 0 8.213 0 5.087 1.22 2.258 3.19.212zm12.57 2.934c1.24 1.3 2.006 3.09 2.006 5.067 0 1.995-.78 3.8-2.04 5.103l-.7-.725c1.083-1.117 1.753-2.666 1.753-4.378 0-1.692-.654-3.224-1.715-4.338l.696-.729zM5.99 3.11l.698.725C5.606 4.952 4.935 6.5 4.935 8.213c0 1.692.655 3.225 1.716 4.339l-.696.729c-1.24-1.3-2.007-3.09-2.007-5.068 0-1.995.78-3.8 2.041-5.103zm4.867 2.02c1.635 0 2.961 1.38 2.961 3.083 0 1.702-1.326 3.082-2.96 3.082-1.636 0-2.962-1.38-2.962-3.082S9.222 5.13 10.857 5.13zm0 1.028c-1.09 0-1.974.92-1.974 2.055 0 1.135.884 2.055 1.974 2.055 1.09 0 1.974-.92 1.974-2.055 0-1.135-.884-2.055-1.974-2.055z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOndas2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ondas2.373bb977.svg";
export { ForwardRef as ReactComponent };